import { register, me, login, update, forgotPassword, unsubscribe, executeActions, getCharges, getRefunds, getSubscription } from "../dataProvider/user";
import { pay } from "../dataProvider/payment";

export const SET_USER = 'USER_SET_USER';
export const SET_EMAIL = 'USER_SET_EMAIL';
export const SET_PAYMENT_NEXT_ACTION = 'USER_SET_PAYMENT_NEXT_ACTION';
export const SET_PAYMENTS = 'USER_SET_PAYMENTS';
export const SET_CLOUD_USAGE = 'SET_CLOUD_USAGE';
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';

export const storeEmail = email => dispatch => dispatch({ type: SET_EMAIL, email });

export const registerUser = (user) => (dispatch, getState) => Promise.resolve()
    .then(() => {
        if (!getState().user.user.id) return register(user);
        return me(getState().user.user.id)
            .then(dbUser => {
                if (!user.metadata) user.metadata = {};
                user.metadata = Object.assign({}, dbUser.metadata, user.metadata);
                user.id = dbUser.id;
                return update(user);
            })
    })
    .then(user => {
        dispatch({ type: SET_USER, user });
        return user;
    })

export function loginUser(username, password) {
    return async function (dispatch, getState) {
        const user = await login(username, password)
        dispatch({ type: SET_USER, user });
        const subscription = await getSubscription(getState().user.user.id)
        dispatch({ type: SET_SUBSCRIPTION, subscription });
        return user;
    }
}

export const logoutUser = () => (dispatch) => dispatch({ type: SET_USER, user: {} })

export const makePayment = card => (dispatch, getState) => pay(getState().user.user, card)
    .then(charge => {
        if (charge.nextAction) dispatch({ type: SET_PAYMENT_NEXT_ACTION, nextAction: charge.nextAction });
        return charge;
    })

export function reloadUser() {
    return async function (dispatch, getState) {
        const user = await me(getState().user.user.id)
        dispatch({ type: SET_USER, user });
        const subscription = await getSubscription(getState().user.user.id)
        dispatch({ type: SET_SUBSCRIPTION, subscription });
        return user;
    }
}

export const getUserData = userId => () => me(userId)

export const updateUser = user => dispatch => update(user)
    .then(user => {
        dispatch({ type: SET_USER, user });
        return user;
    })

export const executeUserAction = () => (dispatch, getState) => executeActions(getState().user.user.id)

export const forgotPassswordUser = (email, lang) => () => forgotPassword(email, lang);

export const unsubscribeUser = (email) => () => unsubscribe(email);

export const reloadPayments = () => (dispatch, getState) => Promise.all([
    getCharges(getState().user.user.id),
    getRefunds(getState().user.user.id)
])
    .then(results => {
        let payments = results[0];
        results[1].forEach(refund => {
            refund.isRefund = true;
            payments.push(refund)
        });

        payments = payments
            .filter(payment => !payment.error && (!!payment.captured || payment.isRefund))
            .sort((payment1, payment2) => new Date(payment2.createdAt) - new Date(payment1.createdAt))

        dispatch({ type: SET_PAYMENTS, value: payments })
    })